import * as yup from 'yup'

export const NEW_APPOINTMENT_VALIDATION = yup.object().shape({
  concern: yup.string().required('Concern is required'),
  estimatedWorkHours: yup
    .number()
    .typeError('Work hours must be a number')
    .positive('Work hours must be greater than zero'),
  notes: yup.string(),
  sendText: yup.bool(),
  sendEmail: yup.bool(),
  vip: yup.bool(),
  waiting: yup.bool()
})
